import styled from "styled-components";
import { colors, types } from "../../libs";
import { Button } from "react-bootstrap";

export const EditorWrapper = styled.div`
  width:100%;
  border-radius: 10px;
`;

export const EditorContent = styled.div`
  flex: 1;
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${colors.background.darkGreen};
    border-radius: 10px;
  }
`;

export const HeaderBar = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background: ${colors.background.lightBlack};
  color:${colors.text.white};
  padding: 10px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.background.lightBlack};
`;


export const HeaderTitle = styled.div`
  font-weight: bold;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const IconButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: ${types.body.normal}
  transition: background-color 0.2s ease;

  &:hover {
    background-color: transparent;
     border-radius: 4px;
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 80vh;
  color: ${colors.background.green};
  & > .spinner-border {
    width: 5rem;
    height: 5rem;
  }
`;

export const SectionWrapper = styled.div`
    border: 1px solid ${colors.background.darkGray};
    padding: 1rem;
    border-radius: 0.4rem;
    background: ${colors.background.black};
    margin: 12px 0px;
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;

`;
export const Description = styled.p`
  ${types.body.normal};
  color: ${colors.text.lightGray};
  margin-bottom: 0.5rem;
`;

export const SectionTitle = styled.h5`
    margin: 0;
`;

export const DeprecationBanner = styled.div`
  background: #3a1f00;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 20px;
`;

export const DeprecationTitle = styled.div`
  font-weight: 700;
  color: #f59e0b;
  margin-bottom: 8px;
  font-size: 0.95rem;
`;

export const DeprecationText = styled.p`
  color: ${colors.text.lightGray};
  margin-bottom: 10px;
  font-size: 0.875rem;
`;

export const DeprecationCode = styled.pre`
  background: ${colors.background.black};
  border: 1px solid ${colors.background.darkGray};
  border-radius: 4px;
  padding: 12px;
  color: ${colors.text.white};
  font-size: 0.8rem;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-all;
`;